import {FaChartPie, FaDownload, FaEye, FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";

export const ACTIONS_LIST = [
  {
    label: "Edit",
    icon: FaPencil,
    perms: ["change_report"],
    condition: "inDraft",
  },
  {
    label: "Review",
    icon: FaEye,
    perms: [],
    condition: "underReview",
  },
  {
    label: "View",
    icon: FaEye,
    perms: [],
    condition: "isSubmitted",
  },
  {
    label: "View_Charts",
    icon: FaChartPie,
    perms: [],
    condition: "isSubmitted",
  },
  {label: "Export", icon: FaDownload, perms: [], condition: "isSubmitted"},
  {label: "Delete", icon: FaTrash, perms: ["delete_report"]},
];

export const LIST_HEADERS = ["name", "status", "report_id", "created_at"];

export const PERMS_FOR_ACTIONS = ["change_report", "delete_report"];
